// angular libs
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';

// marketplace libs
import { AuthenticationService } from '../../services/authentication.service';
import { UserDataService } from '@libs/services/user-data';

/*
 *  This component is used to bind the route to this specific set of logic.  When landing here it should be
 *  because the user was sent here from the Loginizerator with a SUT token to exchange to.
 */
@Component({
  template: `<!-- no template -->`,
  selector: 'app-authentication-token',
})
export class AuthenticationTokenComponent implements OnInit {
  constructor(
    private router: Router,
    private auth: AuthenticationService,
    private activatedRoute: ActivatedRoute,
    private userDataService: UserDataService,
  ) {}

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      const token: string = params['sut'];
      const path: string = params['path'];
      // TODO: this is to ensure we capture the promoCode when a go user jumps to the Hub. Remove once Go is sunset.
      this.userDataService.setPromoCode(params);

      this.auth.exchange(token).subscribe(
        () => {
          // read the path maybe?
          this.router.navigateByUrl(path || '/login-success');
        },
        (error: HttpErrorResponse) => {
          if (error.status === 401) {
            this.router.navigate(['/auth/401']);
          }
          if (error.status === 412) {
            this.router.navigate(['/auth/412']);
          }
        },
      );
    });
  }
}
